// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-dialog__activator:hover {\n  cursor: pointer;\n}\n\n/* Source 1280x1859, crop region x=80 y=15 w=1120 h=215 */\n.screenshot-thumbnail--cropped {\n  width: 100%;\n  aspect-ratio: 1120 / 215;\n  background-repeat: no-repeat;\n  background-size: 114.2857% auto;\n  background-position: 50% 0.912%;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
